import styled, { css, keyframes } from 'common/styled-components';
import { Avatar, List, ListItem, ListItemText, Theme } from '@material-ui/core';

const drawerWidthOpen = 270;
const drawerWidthClosed = 64;
export const Logo = styled.li`
    display: flex;
    justify-content: center;
`;

const Img = styled.img`
    overflow: hidden;
    max-width: none;
    height: 60px;
`;

export const EPImg = styled(Img)`
    width: 0;
`;

export const OImg = styled(Img)`

`;

export const CHImg = styled(Img)`
    width: 0;
`;

const spin = keyframes`
    from {
        transform: rotate(0deg);
    }
    
    to {
        transform: rotate(360deg);
    }
`;

const spinback = keyframes`
    from {
        transform: rotate(0deg);
    }
    
    to {
        transform: rotate(-360deg);
    }
`;

export const IconList = styled(List)<{expanded: boolean, animationsEnabled?: boolean}>`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: 100%;
    width: ${props => props.expanded ? drawerWidthOpen : drawerWidthClosed};
    transition: ${props => props.animationsEnabled && 'all 0.3s cubic-bezier(0.55, 0, 0.1, 1)'};
    
    ${EPImg} {
        width: 0;
    }
        
    ${OImg} {
        animation: ${props => props.animationsEnabled ? `${spinback} 1.1s cubic-bezier(.55, 0, .1, 1)` : ''};
    }
    
    ${CHImg} { 
        width: 0px;
    }
    
    ${props => props.expanded && css`
        vertical-align: top;
        ${Logo} {
            padding-left: 9px;
        }
        ${EPImg} {
            width: 73px;
        }

        ${OImg} {
            animation: ${props.animationsEnabled ? `${spin} 1.1s cubic-bezier(.55, 0, .1, 1)` : ''};
        }

        ${CHImg} { 
            width: 77px;
        }
    `}
`;

export const NavItem = styled(ListItem)`
    && {
        height: 48px;
        padding: 8px ${props => props.selected ? '14px' : '16px'};
        ${props => props.selected ? `border-left: 2px solid ${props.theme.primary.main};` : ``}
    }
    &&:hover {
        background-color: ${props => props.theme.secondary.light} !important;
        border-left: 2px solid ${props => props.theme.primary.main};
        svg, span {
            color: ${props => props.theme.primary.main};
        }
    }
    &&:focus-visible {
        background-color: ${props => props.theme.secondary.light} !important;
        border-left: 2px solid ${props => props.theme.primary.main};
        svg, span {
            color: ${props => props.theme.primary.main};
        }
    }
    &&:focus {
        background: transparent;
    }
    svg, span {
        color: ${props => props.selected ? props.theme.primary.main : props.theme.white.main};
    }
`;

export const NavItemText = styled(ListItemText)`
    text-transform: uppercase;
`;

export const SmallAvatar = styled(Avatar)<{primary?: boolean}>`
    width: 30px !important;
    height: 30px !important;
    font-size: 1rem !important;
    ${props => props.primary ? `
        background: ${props.theme.primary.main} !important;
    ` : ``}
`;

export const CollaborateBtn = styled.div`

`;

export const NavBarStyles = (theme: Theme) => ({
    drawer: {
        width: drawerWidthOpen,
        flexShrink: 0,
        whiteSpace: 'nowrap'
    },
    drawerOpen: {
        width: drawerWidthOpen,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        overflowX: 'hidden',
        width: drawerWidthClosed
    },
    customBadge: {
        color: `${theme.palette.common.black} !important`,
        backgroundColor: theme.palette.common.white
    },
    icon: {
        fontSize: 30
    }
});
